import {CSSProperties, FC} from 'react';


export interface IIconReportVinProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconReportVin: FC<IIconReportVinProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 67 22"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M42.21 10.43c.27.28.4.68.4 1.18s-.11.88-.33 1.14c-.2.24-.46.36-.81.36s-.63-.13-.83-.4c-.2-.27-.3-.62-.3-1.08s.1-.82.3-1.09c.2-.27.47-.41.82-.41.32.01.57.11.75.3Zm-18.29-.37c-.57 0-.91.36-1.01 1.08h2.01c-.03-.72-.36-1.08-1-1.08ZM7.72 8.25c-.57.01-1.02.23-1.34.66-.31.42-.47.98-.47 1.7s.16 1.28.47 1.69c.32.43.77.64 1.33.64.52 0 .94-.18 1.26-.53.38-.42.57-1.02.57-1.81 0-.72-.16-1.28-.47-1.7-.33-.43-.77-.65-1.34-.65ZM67 6v10c0 3.31-2.69 6-6 6H6c-3.31 0-6-2.69-6-6V6c0-3.32 2.69-6 6-6h55c3.31 0 6 2.68 6 6Zm-55.98 4.61c0-1.11-.29-1.98-.88-2.61-.58-.63-1.39-.95-2.43-.95s-1.85.32-2.44.95c-.58.63-.87 1.5-.87 2.61 0 1.22.35 2.14 1.05 2.77.57.52 1.33.78 2.28.78 1.02 0 1.83-.32 2.41-.95.59-.63.88-1.49.88-2.6Zm4.77-1.36h-4.22v.99h1.44V14h1.35v-3.76h1.43v-.99Zm4.86 0H19.3v2.25c-.31.13-.58.2-.8.2-.25 0-.47-.05-.64-.15a.415.415 0 0 1-.24-.39V9.28h-1.35v1.88c0 .41.17.75.5 1.03.38.3.92.46 1.64.46.35 0 .65-.05.89-.16V14h1.35V9.25Zm5.63 2.34c0-1.04-.32-1.76-.95-2.16-.37-.23-.84-.35-1.4-.35-.79 0-1.39.25-1.81.75-.39.45-.58 1.05-.58 1.8 0 .85.24 1.5.7 1.94.42.39.99.59 1.72.59 1.09 0 1.83-.38 2.21-1.14l-1.16-.53c-.19.43-.53.64-1.01.64-.69 0-1.05-.39-1.09-1.18h3.37v-.36Zm4.67-2.34h-4.23v.99h1.44V14h1.35v-3.76h1.44v-.99Zm7.13 0h-4.19V14h1.35v-3.7h1.49V14h1.35V9.25Zm5.91 2.38c0-.75-.21-1.34-.61-1.79-.45-.5-1.09-.76-1.91-.76s-1.46.26-1.91.76c-.39.44-.59 1.04-.59 1.79 0 .82.24 1.46.72 1.91.44.41 1.04.62 1.8.62.81 0 1.44-.25 1.89-.75.4-.45.61-1.03.61-1.78Zm8.8-4.42h-1.47l-1.72 5.4-1.72-5.4h-1.55L48.66 14h1.8l2.33-6.79Zm2.11 0h-1.47V14h1.47V7.21Zm6.97 0h-1.38v4.58l-2.83-4.58H56.2V14h1.38V9.42L60.41 14h1.46V7.21Z" />
        </svg>
    );
};
